/** Pure hulpfuncties voor het verbeterregister (getest in __tests__/verbeterLogica.test.js). */

export const LEEG_FILTER = { zoek: '', fase: '', impact: '', urgentie: '', type: '', statussen: [] };

const bevat = (tekst, q) => String(tekst || '').toLowerCase().includes(q);

/** Filter op fase/impact/urgentie/type (exact) en een vrije zoekterm over titel, tekst, project en mensen. */
export function filterPunten(punten = [], f = LEEG_FILTER) {
  const q = String(f.zoek || '').trim().toLowerCase();
  return punten.filter((p) => {
    if (f.fase && p.fase !== f.fase) return false;
    if (f.impact && p.impact !== f.impact) return false;
    if (f.urgentie && p.urgentie !== f.urgentie) return false;
    if (f.type && p.type !== f.type) return false;
    if (!q) return true;
    if (bevat(p.onderwerp, q) || bevat(p.verbeterpunten, q) || bevat(p.aanleiding, q)) return true;
    if (String(p.nummer || '') === q.replace(/^#/, '')) return true;
    if ((p.projecten || []).some((pr) => bevat(pr.nummer, q) || bevat(pr.naam, q))) return true;
    return [...(p.verantwoordelijke || []), ...(p.mtVerantwoordelijke || []), ...(p.submitter || [])]
      .some((x) => bevat(x.naam, q));
  });
}

/** Kolommen = de Status-opties. Zonder (of met onbekende) status landt een punt in de eerste kolom. */
export function perStatus(punten = [], statussen = []) {
  const m = Object.fromEntries(statussen.map((s) => [s, []]));
  for (const p of punten) (m[p.status] || m[statussen[0]] || []).push(p);
  return m;
}

/** Eigenaar op de kaart: verantwoordelijke, anders MT-verantwoordelijke, anders de indiener. */
export function eigenaar(p) {
  const lijst = (p.verantwoordelijke?.length ? p.verantwoordelijke
    : p.mtVerantwoordelijke?.length ? p.mtVerantwoordelijke : []);
  return lijst.map((x) => x.naam).join(', ');
}

export function korteDatum(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: '2-digit' });
}

/** Airtable-richtext is markdown; op een kaart tonen we platte tekst. */
export function platteTekst(md) {
  return String(md || '')
    .replace(/\*\*|__|~~|`/g, '')
    .replace(/^#+\s*/gm, '')
    .replace(/^\s*[-*]\s+/gm, '• ')
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
    .trim();
}

/** Alleen de velden die echt veranderd zijn (voor PATCH en ongedaan maken). */
export function verschil(oud = {}, nieuw = {}) {
  const uit = {};
  for (const k of Object.keys(nieuw)) {
    const a = oud[k]; const b = nieuw[k];
    const norm = (v) => (Array.isArray(v) ? v.map((x) => (x && x.id) || x) : (v === '' || v === undefined ? null : v));
    if (JSON.stringify(norm(a)) !== JSON.stringify(norm(b))) uit[k] = norm(b);
  }
  return uit;
}

/** Vorige waarden van dezelfde velden, in API-vorm (lijsten van id's). */
export function vorigeWaarden(oud = {}, velden = {}) {
  const uit = {};
  for (const k of Object.keys(velden)) {
    const v = oud[k];
    uit[k] = Array.isArray(v) ? v.map((x) => (x && x.id) || x) : (v === '' || v === undefined ? null : v);
  }
  return uit;
}

/**
 * Ongedaan maken op basis van het serverantwoord ({ vorige, nu }): zet de ÉCHTE vorige
 * stand uit Airtable terug (niet wat het scherm dacht) en stuurt 'verwacht' mee, zodat de
 * server weigert (409) als iemand het sindsdien opnieuw heeft gewijzigd.
 */
export function herstelVanAntwoord(antwoord) {
  const vorige = antwoord?.vorige || {};
  if (!Object.keys(vorige).length) return null;
  return { ...vorige, verwacht: antwoord.nu || {} };
}
